import { Controller } from "@hotwired/stimulus"

// After the admin workspace frame loads, scroll a marked page root into view (e.g. Thing manager from index cards).
export default class extends Controller {
  frameLoaded(event) {
    if (event.target !== this.element) return

    const el = this.element.querySelector("[data-admin-workspace-scroll-top]")
    if (!el) return

    requestAnimationFrame(() => {
      el.scrollIntoView({ block: "start", behavior: "auto" })
    })
    el.removeAttribute("data-admin-workspace-scroll-top")
  }
}
